import { MediaBlock } from 'components/general/blocks/mediaBlock/MediaBlock';
import { NewsItemHeader } from 'components/newsItemHeader/NewsItemHeader';
import { NewsItemType } from 'pages/news/[slug]';
import { DESKTOP_BREAKPOINT } from 'pages/_app';
import style from './FeaturedNewsItem.module.scss';

export type FeaturedNewsItemType = NewsItemType & {};
export const FeaturedNewsItem = ({
  intro: blurb,
  date,
  title,
  category,
  slug,
  hero,
}: FeaturedNewsItemType): JSX.Element => {
  const contentStyle = !blurb ? style.contentCentered : null;
  return (
    <div className={style.container}>
      {hero && (
        <div className={style.image}>
          {/* DEV NOTE: for some reason the deeplink won't render images if we base it on conditional renders? */}
          <div className={style.imageMobile}>
            <MediaBlock media={hero} layout={'responsive'} block_type="media" />
          </div>
          <div className={style.imageDesktop}>
            <MediaBlock
              media={hero}
              layout={'fill'}
              objectFit={'cover'}
              sizes={`${DESKTOP_BREAKPOINT} 50vw,
                      100vw`}
              block_type="media"
            />
          </div>
        </div>
      )}
      <div className={`${style.content} ${contentStyle}`}>
        <p className={style.featureLabel}>Feature:</p>
        <NewsItemHeader
          forceTitle={true}
          title={title}
          date={date}
          blurb={blurb}
          slug={'/news/' + slug}
          category={category}
          showLink={!!blurb}
          showIntro={!!blurb}
        />
      </div>
    </div>
  );
};
